import { render } from "./HeroiconsOutlineClipboardCopy.vue?vue&type=template&id=5a0e161e"
const script = {}

import exportComponent from "/home/nginx/domains/panel.vip-mod.net/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineClipboardCopy.vue"]])

export default __exports__